import * as React from "react";
import { cn } from "lib/utils";

export function FullPageWrapper({ className, ...props }) {
  return (
    <div
      className={cn(
        "flex h-[98vh] w-screen items-center justify-center",
        className
      )}
      {...props}
    />
  );
}
